import {Request} from './Request';

/**
 *
 */
export class UpdateFirmwareRequest implements Request {
    private location: string;
    private retries: number;
    private retryInterval: number;
    private retrieve: Date;
    chargePointSelectList: string[];

    constructor(chargePointSelectList: string[], location?: string, retries?: number, retryInterval?: number, retrieve?: Date) {
        this.location = location;
        this.retries = retries;
        this.retryInterval = retryInterval;
        this.retrieve = retrieve;
        this.chargePointSelectList = chargePointSelectList;
    }

    public toString = (): string => {
        return `UpdateFirmwareRequest (location: ${this.location},
        retries: ${this.retries}, retryInterval: ${this.retryInterval},
        retrieve: ${this.retrieve},
        chargePointSelectList: ${this.chargePointSelectList})`;
    }

    get _location(): string {
        return this.location;
    }

    set _location(value: string) {
        this.location = value;
    }

    get _retries(): number {
        return this.retries;
    }

    set _retries(value: number) {
        this.retries = value;
    }

    get retry_interval(): number {
        return this.retryInterval;
    }

    set retry_interval(value: number) {
        this.retryInterval = value;
    }

    get _retrieve(): Date {
        return this.retrieve;
    }

    set _retrieve(value: Date) {
        this.retrieve = value;
    }
}
